var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUserManagement = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.414,
    height: 24.657,
    viewBox: "0 0 24.414 24.657",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_management",
    "data-name": "User management",
    transform: "translate(22502 7497.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7262",
    "data-name": "Group 7262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4936",
    "data-name": "Path 4936",
    d: "M26.519,13.886,25.04,13.2c.029-.309.043-.593.043-.869s-.014-.561-.043-.869l1.479-.688a.722.722,0,0,0,.382-.878l-.893-2.748a.722.722,0,0,0-.825-.486l-1.6.311A10.386,10.386,0,0,0,22.56,5.565l.792-1.426a.722.722,0,0,0-.207-.935l-2.338-1.7a.722.722,0,0,0-.953.092l-1.113,1.2a10.282,10.282,0,0,0-1.652-.538l-.2-1.62A.722.722,0,0,0,16.174,0h-2.89a.722.722,0,0,0-.717.635l-.2,1.62a10.275,10.275,0,0,0-1.652.538L9.6,1.6a.722.722,0,0,0-.953-.092L6.314,3.2a.722.722,0,0,0-.207.935L6.9,5.565A10.378,10.378,0,0,0,5.871,6.97l-1.6-.311a.722.722,0,0,0-.825.486L2.558,9.893a.722.722,0,0,0,.382.878l1.479.688c-.029.309-.043.593-.043.869s.014.561.043.869l-1.479.688a.722.722,0,0,0-.382.878l.893,2.748A.722.722,0,0,0,4.276,18l1.6-.311a10.382,10.382,0,0,0,1.028,1.4l-.792,1.426a.722.722,0,0,0,.207.935l2.338,1.7A.722.722,0,0,0,9.6,23.06l1.113-1.2a10.282,10.282,0,0,0,1.652.538l.2,1.62a.722.722,0,0,0,.717.635h2.89a.722.722,0,0,0,.717-.635l.2-1.62a10.275,10.275,0,0,0,1.652-.538l1.113,1.2a.722.722,0,0,0,.953.092l2.338-1.7a.722.722,0,0,0,.207-.935l-.792-1.426a10.378,10.378,0,0,0,1.028-1.405l1.6.311a.722.722,0,0,0,.825-.486l.893-2.748A.722.722,0,0,0,26.519,13.886Zm-11.79,5.425a6.983,6.983,0,1,1,6.983-6.983A6.991,6.991,0,0,1,14.729,19.312Z",
    transform: "translate(-22504.521 -7497.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6322",
    "data-name": "Group 6322",
    transform: "translate(-22493.924 -7490.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4938",
    "data-name": "Path 4938",
    d: "M234.99,204.166v-1.407a2.011,2.011,0,0,0-3.99,0v1.407a2.011,2.011,0,0,0,3.99,0Z",
    transform: "translate(-228.814 -201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4939",
    "data-name": "Path 4939",
    d: "M199.361,303.895A2.9,2.9,0,0,0,196.467,301h-2.573A2.9,2.9,0,0,0,191,303.895v.31a7.38,7.38,0,0,0,8.361,0Z",
    transform: "translate(-191 -295.229)",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserManagement, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UserManagement.95a95259.svg";
export { ForwardRef as ReactComponent };